import React from 'react';
import { useSch } from './context';

/** The 7-day lane view of one screen (the prototype's `week()`): coloured segments, dashed = event, red line = now. */
export default function WeekView({ days, previewName, showPreview }) {
  const { t, f, now, showName, col } = useSch();
  return (
    <div className="sch6-card" style={{ padding: 14 }}>
      <div className="sch6-week">
        {days.map((d) => (
          <div key={d.date} className={`sch6-wrow${d.date === now.date ? ' sch6-today' : ''}`}>
            <div className="sch6-dl"><b>{f.dayName(d.dow)}</b>{f.num(Number(d.date.slice(8, 10)))}</div>
            <div className="sch6-lane">
              {d.segs.filter((s) => s.kind !== 'default').map((s) => (
                <span
                  key={`${s.a}-${s.show}`}
                  className={`sch6-seg2${s.kind === 'event' ? ' sch6-ev' : ''}`}
                  style={{ background: col(s.show), insetInlineStart: `${(s.a / 1440) * 100}%`, width: `${((s.b - s.a) / 1440) * 100}%` }}
                  title={showName(s.show)}
                >{showName(s.show)}</span>
              ))}
              {d.date === now.date && <span className="sch6-nowline" style={{ insetInlineStart: `${(now.min / 1440) * 100}%` }} aria-label={t('sch6.legend_now')} />}
            </div>
          </div>
        ))}
        <div className="sch6-axis"><span />
          <div className="sch6-ticks">
            {[0, 6, 12, 18, 24].map((x) => (
              <span key={x} style={{ insetInlineStart: `${(x / 24) * 100}%`, transform: `translateX(${x === 0 || x === 24 ? '0' : '50%'})` }}>{x === 24 ? '' : f.tm(x * 60)}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="sch6-legend" style={{ marginTop: 10 }}>
        {showPreview && <span>{t('sch6.preview', { name: previewName })}</span>}
        <span><i className="sch6-sw" style={{ background: 'var(--track)', border: '1px solid var(--line)' }} />{t('sch6.legend_empty')}</span>
        <span><i className="sch6-sw sch6-swev" />{t('sch6.legend_event')}</span>
        <span><i className="sch6-sw" style={{ background: 'var(--danger)', width: 3 }} />{t('sch6.legend_now')}</span>
      </div>
    </div>
  );
}
